import { solarMachine } from '~/machines/solar-funnel';
import { fetchBillingExperienceOptions as fetchBillingExperienceOptionsService } from '~/services';
import { BillingDataSource } from '~/typings/context';
import { ContractTag } from '~/typings/graphql';
import { UTILITY_IDS } from '~/utils/constants';
import { getInitialState } from '~/utils/funnels';
import { iSolarFunnelRedirects } from '~/utils/redirects';
import { config } from './config';

export const funnelMachine = () =>
  solarMachine({
    id: config.id,
    initialState: getInitialState(config.id, solarMachine),
    utility: {
      context: { redirect: iSolarFunnelRedirects },
    },
    user: {
      context: { requirePhone: true, showInviteCode: true },
    },
    enrollment: {
      services: {
        fetchBillingExperienceOptions,
      },
    },
    legal: {
      context: {
        contractTags: context =>
          context.funnelPacket.utility.id === UTILITY_IDS.NYSEG ? [ContractTag.Nyseg] : undefined,
      },
    },
  }).withConfig({
    services: {
      fetchBillingExperienceOptions,
    },
  });

const fetchBillingExperienceOptions = async context => {
  const { billingExperienceOptions } = await fetchBillingExperienceOptionsService({
    utilityId: context.funnelPacket!.utility.id,
    enrollmentDataSourceName: context.enrollmentSelection!,
  });

  // limit to UCB if available
  if (billingExperienceOptions.includes('ucb')) {
    return { billingExperienceOptions: ['ucb'] as BillingDataSource[] };
  } else {
    return {
      billingExperienceOptions: billingExperienceOptions.slice(0, 1) as BillingDataSource[],
    };
  }
};
